import { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'

import LoteCard from '../../../components/LoteCard'
import { TitleArea } from '../../styles'
import { IOutrasOfertasProps } from './OutrasOfertasComponent.types'

const OutrasOfertas: FunctionComponent<IOutrasOfertasProps> = ({
  lotes,
  index,
  enviaCarga,
  visualizaCarga,
}) => {
  const proximosLotes = () => {
    if (index + 4 <= lotes.length) {
      return lotes.slice(index + 1, index + 4)
    }
    return lotes.slice(0, 3)
  }
  const amostraDeLotes = proximosLotes()

  return (
    <div>
      <TitleArea>Outras ofertas</TitleArea>

      <Grid container spacing={4}>
        {amostraDeLotes.map(lote => {
          return (
            <Grid item xs={12} md={4} key={lote.id}>
              <LoteCard
                lote={{
                  id: lote.id,
                  origem: lote.origem,
                  destino: lote.destino,
                  valor: lote.valor,
                  produto: lote.produto,
                  empresa_logomarca: lote.empresa_logomarca,
                  cliente_logomarca: lote.cliente_logomarca,
                  tipo_pagamento: lote.tipo_pagamento,
                }}
                lotes={lotes}
                index={0}
                setLoading={() => true}
                setOpen={() => true}
                setMessages={() => ''}
                onClickEnviarCarga={() =>
                  enviaCarga(lote.id, lote.origem, lote.destino)
                }
                onClickVisualizar={() =>
                  visualizaCarga(lote, lote.origem, lote.destino)
                }
              />
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}

export default OutrasOfertas
